<div class="row">
  <div class="createCPPOuter">

    <div class="create-cpp-page">
      <div class="order-view-sec breadcrumbOuter padding-0" id="orderView1" [ngClass]="'col-md-12'">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item active">
              <a href="javascript:void(0)" routerLink="/sro/error/order-maintenance-dashboard">Error Order Maintenance</a>
              <i class="fas fa-angle-right"></i>
            </li>
            <li class="breadcrumb-item breadcrumbColor">
              <span *ngIf="webOrderNumber>0">webOrderNumber # : {{webOrderNumber}}</span>
            </li>
          </ol>
        </nav>
      </div>
      <!--Crop year and filter section-->
      <div class="OrderReleaseTop">
        <div class="row">
          <!--Sold To Select List-->
          <div class="col-md-4 material-select" [class.cpp-create-soldTo]="!soldToAccount">
            <ng-select name="ddlSoldTo"
                       [items]="soldToFacility"
                       class="custom-select-grower grower-add-drop ng-select-disabled"
                       [virtualScroll]="true"
                       [(ngModel)]="soldToAccount"
                       bindLabel="accountNameCityState"
                       [disabled]="true"
                       bindValue="accountNumber"
                       placeholder="Sold To: (Will Display after selection of Ship To):"
                       [loading]="soldToDataLoading"
                       [closeOnSelect]="true"
                       [searchFn]="accountSearchFn">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <h4 class="name greenColor" [ngOptionHighlight]="search">
                        {{item.accountName}}
                      </h4>
                      <p class="address" [ngOptionHighlight]="search">
                        {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </p>
                      <p class="phoneNo" [ngOptionHighlight]="search">
                        {{item.primaryPhoneNumber}}
                      </p>
                      <p class="grower-nos">
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Account #: {{item.accountNumber}}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
          </div>

          <!--Ship to - Confirmation Email Section-->

          <div class=" col-md-4 material-select">
            <ng-select name="ddlShipTo"
                       [items]="shipToFacilityList"
                       class="custom-select-grower grower-add-drop"
                       [virtualScroll]="true"
                       [(ngModel)]="shipToAccount"
                       bindLabel="accountNameCityState"
                       [disabled]="true"
                       bindValue="accountNumber"
                       placeholder="Ship To:"
                       [loading]="shipToDataLoading"
                       [closeOnSelect]="true"
                       [searchFn]="accountSearchFn"
                       (change)="getShipTo($event)"
                       (clear)="getShipTo($event)">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <h4 class="name greenColor" [ngOptionHighlight]="search">
                        {{item.accountName}}
                      </h4>
                      <p class="address" [ngOptionHighlight]="search">
                        {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </p>
                      <p class="phoneNo" [ngOptionHighlight]="search">
                        {{item.primaryPhoneNumber}}
                      </p>
                      <p class="grower-nos">
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Account #: {{item.accountNumber}}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
          </div>

          <div class=" col-md-4 material-select">
            <ng-select name="ddlDeliverTo"
                       [items]="deliverToList"
                       class="custom-select-grower grower-add-drop"
                       [virtualScroll]="true"
                       [(ngModel)]="deliverToAccount"
                       bindLabel="accountNameCityState"
                       bindValue="accountNumber"
                       [disabled]="true"
                       placeholder="Deliver To:"
                       [loading]="deliverToDataLoading"
                       [closeOnSelect]="true"
                       [searchFn]="accountSearchFn"
                       (change)="getDeliverTo($event)"
                       (clear)="getDeliverTo($event)">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <h4 class="name greenColor" [ngOptionHighlight]="search">
                        {{item.accountName}}
                      </h4>
                      <p class="address" [ngOptionHighlight]="search">
                        {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </p>
                      <p class="phoneNo" [ngOptionHighlight]="search">
                        {{item.primaryPhoneNumber}}
                      </p>
                      <p class="grower-nos">
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Account #: {{item.accountNumber}}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 specialInst padding-t4">
            <mat-form-field class="example-full-width">
              <label class="checkbox-color">Shipping Instruction:</label>
              <textarea style="resize:none;height:auto;" matInput rows="6"
                        (input)="hasHeaderInfoChanged('Special Instructions');"
                        [maxLength]="500"
                        [readonly]="readOnlyAccess"
                        [disabled]="true"
                        [(ngModel)]="specialInstructionText"></textarea>
            </mat-form-field>
          </div>
        </div>

        <div class="row">

          <div class="col-md-4 purchaseOrder margin-t12">
            <mat-form-field class="wide100">
              <mat-label>Customer PO#:</mat-label>
              <input matInput type="text" name="purchaseOrder" NumbersOnly [disabled]="true"
                     (input)="hasHeaderInfoChanged('PO');"
                     [(ngModel)]="purchaseOrder"
                     [readonly]="readOnlyAccess"
                     [maxLength]="25">
            </mat-form-field>
          </div>
          <!--<div class="col-md-4 purchaseOrder margin-t12">
            <mat-form-field class="wide100" [ngClass]="{valid : (isNotValid ==false)}">
              <mat-label>Email:</mat-label>
              <input matInput type="email" name="accountEmail" [disabled]="true"
                     [(ngModel)]="accountEmail"
                     [readonly]="readOnlyAccess"
                     [pattern]="emailPattern"
                     (keyup)="validateEmail()"
                     (input)="hasHeaderInfoChanged('Email Address');"
                     email="true">
              <mat-error *ngIf="isNotValid">
                Email not valid.
              </mat-error>
            </mat-form-field>
          </div>-->
          <div class="col-md-4 checkbox-color margin-t35">
            Customer Pickup:  <mat-checkbox #CustomerPickupCheck class="custom-checkbox margin-l10"
                                            [disabled]="true"
                                            [style.display]=""
                                            [checked]=""
                                            (input)="hasHeaderInfoChanged('Customer Pickup');"
                                            [indeterminate]=""
                                            [(ngModel)]="isCustomerPickup"></mat-checkbox>
          </div>
        </div>
      </div>

      <div class="OrderReleaseDetail">
        <!--Product Detail section-->
        <div class="form-sec">
          <div class="row margin-r0 margin-b20">
            <div class="col-sm-2 col-md-2 filterRow">
              <mat-checkbox #Allcheck class="custom-checkbox select-all-check"
                            [checked]="sroProductItemsDataSource.data.length > 0 && (selectedCount > 0) && (selectedCount == sroProductItemsDataSource.data.length)"
                            [indeterminate]="sroProductItemsDataSource.data.length > 0 && (selectedCount > 0) && (selectedCount < sroProductItemsDataSource.data.length)"
                            [style.display]="disablecheckbox || readOnlyAccess ? 'none' : 'block'"
                            (change)="enableAllCheckBoxes(Allcheck._checked);"
                            matTooltip="Select All Lines" [matTooltipPosition]="'above'"></mat-checkbox>

              <div class="product-tools-outer" *ngIf="showTabs && (!isSearchClicked && editToolKit)">
                <div class="product-tools-tab" appClickOutside (clickOutside)="tabNode=''">

                  <div class="tab-bar margin-l15 col-md-10">
                    <ul>
                      <li (click)="showTab('delivery')" [ngClass]="{'active': tabNode==='delivery'}" class="seperator" matTooltip="Set Delivery Date" [matTooltipPosition]="'above'">
                        <i class="icon-ico-delivery"></i>
                      </li>
                      <li (click)="showTab('delete')" [ngClass]="{'active': tabNode==='delete'}" class="seperator" matTooltip="Delete Items from Order" [matTooltipPosition]="'above'">
                        <i class="icon-ico-trash"></i>
                      </li>
                    </ul>
                  </div>

                  <div class="tab-content">
                    <div *ngIf="tabNode==='delivery'" class="deliveryDate">
                      <div class="tab-content-heading">
                        For: {{shipToAccountName}}
                      </div>
                      <div class="tab-content-detail">
                        <ngb-datepicker [(ngModel)]="datemodel" [dayTemplate]="customDay" [markDisabled]="isDisabled" ngbDatepicker #d="ngbDatepicker"></ngb-datepicker>
                        <ng-template #customDay let-date let-currentMonth="currentMonth" let-selected="selected" let-disabled="disabled" let-focused="focused">
                          <span class="custom-day" [class.weekend]="isWeekend(date)" [class.focused]="focused"
                                [class.bg-primary]="selected" [class.hidden]="date.month !== currentMonth" [class.text-muted]="disabled">
                            {{date.day}}
                          </span>
                        </ng-template>
                        <div class="btn-Sec text-center">
                          <button mat-raised-button class="btns normal-large-btn fullWidthBtn" color="primary" (click)="SetAllFields('deliverydate',datemodel)">Save</button>
                        </div>
                      </div>
                    </div>

                    <div *ngIf="tabNode==='delete'" class="delete-product">
                      <div class="tab-content-heading">
                        For: {{shipToAccountName}}
                      </div>
                      <div class="tab-content-detail">
                        <p>Are you sure you want to delete <span> {{selectedCount}} </span> selected Items(s)?</p>
                        <div class="btn-area">
                          <button mat-raised-button class="btns normal-large-btn" color="primary" (click)="SetAllFields('delete',true)">Yes</button>
                          <button mat-raised-button class="btns normal-large-btn" color="primary" (click)="SetAllFields('delete',false)">No</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-8 text-center diclaimermsg">
              <div>{{this.disclaimerMessage}}</div>
              <div>{{this.dynamicDisclaimerMessage}}</div>
            </div>
            <div class="col-md-2 text-right showProdTxt" *ngIf="!isReleased">
              <div class="d-none d-sm-none d-md-block">
                <button mat-raised-button class="btns" *ngIf="(!readOnlyAccess)" [disabled]="!isAddProductEnable" (click)="openBusinessRuleAnalysisDialog()">Business Rule Analysis</button>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 productTableOuter">
            <div class="tableContainer" id="cppOrderView">
              <table mat-table #productTable [dataSource]="sroProductItemsDataSource" multiTemplateDataRows matSort matSortDirection="desc" class="matTables productTable resultTable">
                <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
                  <div *ngIf="column=='checkbox'"><th mat-header-cell *matHeaderCellDef class="checkBoxCol">&nbsp;</th>
            </div>
            <div *ngIf="column=='product'"><th mat-header-cell *matHeaderCellDef class="prodNameBlock">Product </th></div>
            <div *ngIf="column=='viewDetail'"><th mat-header-cell style="color:white" *matHeaderCellDef class="package text-center">View Detail</th></div>
            <div *ngIf="column=='packageSize'"><th mat-header-cell *matHeaderCellDef class="package text-center">Package Size</th></div>
            <div *ngIf="column=='totalGallon'"><th mat-header-cell *matHeaderCellDef class="totalGallon text-center">Total Gallons</th></div>
            <div *ngIf="column=='quantity'"><th mat-header-cell *matHeaderCellDef class="quantityBlock text-center">Quantity</th></div>
            <div *ngIf="column=='orderUOM'"><th mat-header-cell *matHeaderCellDef class="orderUOMBlock text-center">Order UOM</th></div>
            <div *ngIf="column=='itemTotal'"><th mat-header-cell *matHeaderCellDef class="itemTotal text-center">Item Total</th></div>
            <div *ngIf="column=='deliveryDate'"><th mat-header-cell *matHeaderCellDef class="deliveryDateBlock text-center">Requested Arrival Date</th></div>

            <td mat-cell *matCellDef="let element">
              <div *ngIf="column=='checkbox'" class="text-center CheckBoxCol"
                   (click)="showDetails($event, element,column)"
                   matTooltip="Select Product" [matTooltipPosition]="'above'">
                <mat-checkbox #SingleCheck class="custom-checkbox"
                              [style.display]="'contents'"
                              [disabled]="readOnlyAccess"
                              (change)="enableCheckBoxSingle(SingleCheck._checked)"
                              [(ngModel)]="element.isSelected"></mat-checkbox>
              </div>

              <div *ngIf="column=='product'">
                <span *ngIf="!readOnlyAccess" (click)="selectForFavorite(element)" class="favIcon">
                  <i *ngIf="!element.isFavorite" class="far fa-star"></i>
                  <i *ngIf="element.isFavorite" class="fas fa-star"></i>
                </span>
                <div class="order-info">
                  <p>{{element.itemVendorName}}</p>
                  <p class="grower-name">{{element.itemDescription}}</p>
                  <p><span *ngIf="element.yourPrice && plAccess==true && element.yourPrice!='' && element.yourPrice!=null && element.yourPrice!=0" class="growerUnit">${{element.yourPrice | number:'1.4-4'}}/{{element.pricingUnitOfMeasure}}</span></p>
                  <p><span *ngIf="element.paymentTerms && plAccess==true" class="paymentTerm">{{element.paymentTerms}}</span></p>
                </div>
              </div>

              <div *ngIf="column=='viewDetail'" (click)="showProductDetails(element);" class="showHideDetails">
                <a>{{element.isProductDetailDisplayed ? 'Hide Product Details':'View Product Details' }}</a>
              </div>

              <div *ngIf="column=='packageSize'" class="measureUnit largeTableTxt text-center">
                {{element.packageSize}}
              </div>


              <div *ngIf="column=='totalGallon'" class="measureUnit largeTableTxt text-center">
                {{element.totalGallon | number: '1.0-2'}}
              </div>

              <div *ngIf="column=='quantity'" class="quantityBlock largeTableTxt text-center">
                {{element.quantity}}
              </div>

              <div *ngIf="column=='orderUOM'" class="largeTableTxt text-center">
                {{element.uom}}
              </div>
              <div *ngIf="column=='deliveryDate'" class="deliveryDateBlock">
                <div class="text-center deliveryDatePicker padding-0 padding-t10">
                  <mat-form-field [class.invalid-field]="element.deliveryDate?false:true">
                    <input readonly matInput [matDatepicker]="picker" (focus)="picker.open();" [matDatepickerFilter]="dateFilter"
                           [(ngModel)]="element.deliveryDate" (dateChange)="validateDate(element, $event)">
                    <mat-datepicker-toggle [disabled]="readOnlyAccess" matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker [disabled]="readOnlyAccess" #picker></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
            </td>
            </ng-container>

            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
            <ng-container matColumnDef="expandedDetail">
              <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                <div [style.display]="element.isProductDetailDisplayed ? 'block' : 'none'">
                  <div class="cpp-prod-info">
                    <table style="width:100%">
                      <thead>
                        <tr>
                          <th width="10%">
                            Item #
                          </th>
                          <th width="13%">
                            GTIN
                          </th>
                          <th width="13%">
                            <strong>Product Line </strong>
                          </th>
                          <th width="20%">
                            Active Ingredients
                          </th>
                          <!--<th width="10%">
                            National Price
                          </th>-->
                          <th width="13%">
                            Pallet Quantity
                          </th>
                          <th width="13%">
                            Restricted Use
                          </th>
                          <th width="13%">
                            Non-Returnable
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td width="10%">
                            <p>{{element.itemNumber}}</p>
                          </td>
                          <td width="13%">
                            <p>{{element.gtin}}</p>
                          </td>
                          <td width="13%">
                            <p>{{element.productLine}}</p>
                          </td>
                          <td width="20%">
                            <p>{{element.activeIngredient}}</p>
                          </td>
                          <!--<td width="10%">
                            <p> {{element.price | number:'1.4-4'}}</p>
                          </td>-->
                          <td width="13%">
                            |
                            <p>{{element.palletQuantity | number:'1.4-4'}}</p>
                          </td>
                          <td width="13%">
                            <p>{{element.restrictedUse}}</p>
                          </td>
                          <td width="13%">
                            <div [ngClass]="{'oval-shape returnable':( element.returnable ==='X')}"><p>{{element.returnable}}</p></div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="inline-error" *ngIf="element.lineErrors.errors.length > 0" id="error_{{element.lineErrors.rowId}}">
                  <div class="row">
                    <div class="col-md-9">
                      <ol class="error-list">
                        <li *ngFor="let err of element.lineErrors.errors">
                          {{err.error}}
                      </ol>
                    </div>
                    <div class="col-md-3 revertToPrev" (click)="revertToPreviousError(element, true)">
                      <span>
                        Revert to Previous.
                        <i class="icon-ico-Reply"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
            <tr mat-row *matRowDef="let element; columns: displayedColumns;"
                class="example-element-row"
                [class.example-expanded-row]="expandedElement === element"
                (click)="expandedElement = expandedElement === element ? null : element"></tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
            </table>

            <div *ngIf="sroProductItemsDataSource == undefined || sroProductItemsDataSource?.data.length == 0" class="noDataMsg">
              <p>No Record Found.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--Error section on table-->
  <div class="common-error-block cpp-create" *ngIf="showErrorBlock && errorMsgs.length > 0 && errorMsgs[index].errors.length > 0">
    <div class="row">
      <div class="col-md-2 padding-r0 errCountOuter">

        <span class="errorCounting">
          {{currentErrorRow}} of {{errorMsgs.length}}
        </span>
      </div>
      <div class="col-md-6 padding-l0 ">
        <ul class="errorMsg">
          <li *ngFor="let err of errorMsgs[index].errors">
            <p> {{err.error}}</p>
          </li>
        </ul>
      </div>
      <div class="col-md-4 button-sec text-right">
        <button mat-raised-button class="btns" color="primary" (click)="revertAllChanges()">Revert All Errors</button>
        <button mat-raised-button class="btns" color="primary" *ngIf="errorMsgs && errorMsgs.length>0" (click)="nextError()">Next Error</button>
      </div>
    </div>
  </div>

  <div class="SeedFulfillBtnSec">
    <div class="row padding-l20">
      <div class="col-md-12" style="display: contents;">
        <button mat-raised-button class="btns" [disabled]="(!isResubmitOrderEnable)" (click)="resubmitOrder()" [style.display]="'inline-block' ">Resubmit Order</button>
        <button mat-raised-button class="btns" [disabled]="(!isSaveDeletedItemsEnable)" (click)="saveDeletedItems()" [style.display]="'inline-block' ">Save</button>
      </div>
    </div>
  </div>
</div>
</div>
